import { render, staticRenderFns } from "./SoccerStadium.vue?vue&type=template&id=0c10893f&scoped=true"
import script from "./SoccerStadium.vue?vue&type=script&lang=js"
export * from "./SoccerStadium.vue?vue&type=script&lang=js"
import style0 from "./SoccerStadium.vue?vue&type=style&index=0&id=0c10893f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10893f",
  null
  
)

export default component.exports